<script lang="ts" setup>
import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'
import RedirectButton from '@/components/RedirectButton/RedirectButton.vue'
import { getEnv } from '@/utils/environmentService'
import { getLanguage } from '@/helpers/language-helper'

defineProps({ data: Object })

const webtraderAppLink = 'https://webtrader.hmarkets.' + getEnv() + '/' + getLanguage()

</script>
<template>
  <div class="flex flex-col items-center lg:flex-row lg:items-start">
    <div
      class="flex flex-col md:justify-start items-center md:items-start w-full md:max-w-[346px] mt-10 md:ml-10"
    >
      <div>
        <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
      </div>
      <div
        class="w-full mt-5 text-base px-[10px] md:px-[0px] lg:w-[311px] lg:h-[180px] -tracking-tightest"
      >
        {{ data?.description }}
      </div>
      <div class="flex justify-center w-full lg:hidden">
        <img loading="lazy" :src="data?.main_image_mobile" :alt="data?.main_image.alt" />
      </div>
      <div class="lg:mt-5 mt-0 w-full md:px-0 px-[10px] md:max-w-[311px] d">
        <RedirectButton
          :href="data?.action_button_link"
          :text="data?.action_button_text"
          type="primary"
        />
        <RedirectButton
          :href="webtraderAppLink"
          :text="data?.secondary_button_text"
          type="secondary"
        />
      </div>
    </div>
    <div
      class="items-center justify-center hidden mt-12 lg:block lg:ml-[px] 1440:ml-[171px] min-h-[596px]"
    >
      <img loading="lazy" :src="data?.main_image" :alt="data?.main_image.alt" />
    </div>
  </div>
  <TradingFooter
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="lg:mb-20"
  ></TradingFooter>
</template>
